// export const PAGINATION_DEFAULT_VALUE = { pageSize: 10, currentPage: 1 };
export const PAGINATION_DEFAULT_VALUE = { size: 10, page: 1 };
